import { useEffect, useState } from 'react';
import { collectionGroup, onSnapshot } from 'firebase/firestore';
import { firestore } from '../services/firebase/firebase';

/**
 * Nombre de demandes soumises à traiter (statut « nouvelle »)
 * Utilisé pour le badge circulaire sur le lien « Demandes » de la navigation.
 */
export const useNewRequestsCount = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    // collectionGroup « creation_request » (le doc creation_form en fait partie)
    const requestsRef = collectionGroup(firestore, 'creation_request');
    const unsubscribe = onSnapshot(requestsRef, (snapshot) => {
      const n = snapshot.docs.filter(
        (doc) => doc.id === 'creation_form' && doc.data().status === 'nouvelle'
      ).length;
      setCount(n);
    });

    return unsubscribe;
  }, []);

  return count;
};
